import { render } from "./AddAreaEcoSelf.vue?vue&type=template&id=3d5ef282&scoped=true"
import script from "./AddAreaEcoSelf.vue?vue&type=script&lang=js"
export * from "./AddAreaEcoSelf.vue?vue&type=script&lang=js"

import "./AddAreaEcoSelf.vue?vue&type=style&index=0&id=3d5ef282&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5ef282"]])

export default __exports__